export class AwsRdsResource {
    'sizeBytes';
    'clusterId';
    'engine';
    'engineVersion';
    'storageSettings';
    'databaseName';
    'instanceClass';
    'isMultiAZ';
    'isPubliclyAccessible';
    'backupRetentionDays';
    'aurora';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sizeBytes",
            "baseName": "sizeBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "clusterId",
            "baseName": "clusterId",
            "type": "string",
            "format": ""
        },
        {
            "name": "engine",
            "baseName": "engine",
            "type": "AwsRdsEngine",
            "format": ""
        },
        {
            "name": "engineVersion",
            "baseName": "engineVersion",
            "type": "string",
            "format": ""
        },
        {
            "name": "storageSettings",
            "baseName": "storageSettings",
            "type": "AwsRdsResourceStorageSettings",
            "format": ""
        },
        {
            "name": "databaseName",
            "baseName": "databaseName",
            "type": "string",
            "format": ""
        },
        {
            "name": "instanceClass",
            "baseName": "instanceClass",
            "type": "string",
            "format": ""
        },
        {
            "name": "isMultiAZ",
            "baseName": "isMultiAZ",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "isPubliclyAccessible",
            "baseName": "isPubliclyAccessible",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "backupRetentionDays",
            "baseName": "backupRetentionDays",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "aurora",
            "baseName": "aurora",
            "type": "AwsRdsResourceAurora",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsRdsResource.attributeTypeMap;
    }
    constructor() {
    }
}
